import { SVGProps, Ref, forwardRef } from "react";

const UpDownArrowIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 20 18"
    fill="currentColor"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Up Down Arrow Icon"
    {...props}
  >
    <title id="Up Down Arrow Icon">Up Down Arrow Icon</title>
    <path
      stroke="#9AA4B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 1v16m0 0-4-4m4 4 4-4m6 4V1m0 0-4 4m4-4 4 4"
    />
  </svg>
);

const ForwardRef = forwardRef(UpDownArrowIcon);
export default ForwardRef;
